import ProtectedRoute from '@commons/layouts/ProtectedRoute'
import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { adminRoutes } from './routes/admin.route'
import Dashboard from '@pages/admin/dashboard'
import AdminLogin from '@pages/admin/auth/Login'
import PaymentSuccess from '@pages/payment/payment-success'
import PaymentFailure from '@pages/payment/payment-failure'
import PaymentStatus from '@pages/payment/payment-status'
import PayBridgeSuccess from '@pages/payment/pay-bridge-success'
import PayBridgeFailure from '@pages/payment/pay-bridge-failure'
const AdminLayout = lazy(
  () => import('@commons/layouts/private/admin/AdminLayout'),
)
const App = () => {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="payment-success" element={<PaymentSuccess />} />
          <Route path="payment-failure" element={<PaymentFailure />} />
          <Route path="payment-status" element={<PaymentStatus />} />
          <Route path="pay-bridge-success" element={<PayBridgeSuccess />} />
          <Route path="pay-bridge-failure" element={<PayBridgeFailure />} />
          <Route path="/" element={<Navigate to="/admin-login" replace />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute
                allowedRoles={['admin']}
                Component={AdminLayout}
              />
            }
          >
            <Route index element={<Dashboard />} />
            {adminRoutes.map((item, i) => (
              <Route {...item} key={i} />
            ))}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
